import { textMuted, white } from '@/theme/colors'
import styled from 'styled-components'

export const ChartCard = styled.div`
	background-color: ${white};
	border-radius: 12px;
	padding: 1.5rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	margin-top: 1.5rem;
`

export const ChartTitle = styled.h2`
	margin: 0 0 1rem;
	font-size: 1.1rem;
	font-weight: 600;
	color: ${textMuted};
`

export const Legend = styled.div`
	display: flex;
	gap: 1.25rem;
	margin-bottom: 0.75rem;
	flex-wrap: wrap;
`

export const LegendItem = styled.span`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	font-size: 0.85rem;
	color: ${textMuted};
`

export const Swatch = styled.span<{ $color: string }>`
	width: 12px;
	height: 12px;
	border-radius: 3px;
	background-color: ${({ $color }) => $color};
`

export const Chart = styled.svg`
	width: 100%;
	height: auto;
	display: block;
`

export const EmptyState = styled.div`
	color: ${textMuted};
	font-size: 0.95rem;
	padding: 1rem 0;
`
